import { useContext, useEffect, useState } from 'react'
import { OptimizelyContext } from '../OptimizelyContext'
import { OptimizelyDecisionWithoutUserContext, OptimizelyFeatureFlags } from 'models/Optimizely'

export const useFeatureFlag = (
  flagName: OptimizelyFeatureFlags,
): OptimizelyDecisionWithoutUserContext => {
  const { featureFlags } = useContext(OptimizelyContext)
  const [urlOverride, setUrlOverride] = useState<boolean | null>(null)

  useEffect(() => {
    // Only run in browser and in non-production environments
    if (typeof window !== 'undefined' && process.env.APP_ENV !== 'prod') {
      const params = new URLSearchParams(window.location.search)
      const featureFlagParam = params.get(`ff_${flagName}`)

      if (featureFlagParam === 'true' || featureFlagParam === 'false') {
        setUrlOverride(featureFlagParam === 'true')
      }
    }
  }, [flagName])

  // If URL override is set AND we're not in production, use it
  if (urlOverride !== null && process.env.APP_ENV !== 'prod') {
    return {
      enabled: urlOverride,
      flagKey: flagName,
      ruleKey: 'url-override',
      variationKey: urlOverride ? 'enabled' : 'disabled',
      variables: {},
      reasons: ['URL parameter override'],
    }
  }

  return featureFlags[flagName] || { enabled: false }
}
